import { render, staticRenderFns } from "./electric-charge-add-bill.vue?vue&type=template&id=48180142&scoped=true&"
import script from "./electric-charge-add-bill.vue?vue&type=script&lang=js&"
export * from "./electric-charge-add-bill.vue?vue&type=script&lang=js&"
import style0 from "./electric-charge-add-bill.vue?vue&type=style&index=0&id=48180142&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48180142",
  null
  
)

export default component.exports